import CareerParamsComponent from "./careerParamsComponent.js"

class CareerFormSearchComponent {

    private sidebarFilterForm!: HTMLFormElement;
    private searchForm!: HTMLFormElement;

    private clearFilterButton!: HTMLButtonElement;

    public onDomLoaded() {
        this.clearFilterButton = document.getElementById("filter-sidebar__clear-button") as HTMLButtonElement;

        this.clearFilterButton.addEventListener("click", () => {
            this.clearFilter()
        }, { once: true })

        //Top search
        this.searchForm = document.getElementById("searchForm") as HTMLFormElement;

        this.searchForm.addEventListener("submit", (event: SubmitEvent) => {
            event.preventDefault();

            this.handleSearch(new FormData(event.target as HTMLFormElement));
        })

        //Sidebar filter
        this.sidebarFilterForm = document.getElementById("filter-sidebar") as HTMLFormElement;

        this.sidebarFilterForm.addEventListener("submit", (event: SubmitEvent) => {
            event.preventDefault();

            this.handleSidebarFilter(new FormData(event.target as HTMLFormElement));
        });
    }

    public clearFilter() {
        CareerParamsComponent.searchParams = new URLSearchParams();

        CareerParamsComponent.reload();
    }

    public handleSearch(formData: FormData) {
        CareerParamsComponent.searchParams.set("Search", formData.get("search")?.toString() ?? "");

        CareerParamsComponent.reload();
    }

    public handleSidebarFilter(formData: FormData) {
        const appendArray = (key: string, values: FormDataEntryValue[]) => {
            CareerParamsComponent.searchParams.delete(key);

            values.forEach((v) => {
                CareerParamsComponent.searchParams.append(key, v.toString());
            })
        };

        //Companies
        const selectedCompanyNames = formData.getAll("companies");

        appendArray("CompanyNames", selectedCompanyNames);

        //Departments
        const selectedDepartmentNames = formData.getAll("departments");

        appendArray("DepartmentNames", selectedDepartmentNames);

        //Functions
        const selectedFunctionNames = formData.getAll("functions");

        appendArray("FunctionNames", selectedFunctionNames);

        //Functional areas
        const selectedFunctionalAreas = formData.getAll("functional_areas");

        appendArray("FunctionalAreas", selectedFunctionalAreas);

        //Company addresses
        const selectedCompanyAddresses = formData.getAll("company_addresses");

        appendArray("CompanyAddresses", selectedCompanyAddresses);

        //Done
        CareerParamsComponent.reload();
    }
}

const component = new CareerFormSearchComponent();

export default component;

window.addEventListener("DOMContentLoaded", () => component.onDomLoaded(), { once: true });